<template>
  <div class="config-panel" :key="selectedObjectModelProperty ? selectedObjectModelProperty.client_id : 'None'" v-bind:class="{ 'element-selected': (selectedObjectModelProperty || selectedPropertySection)}">
    <row class="panel-title">
      <prefix>
        <button class="btn-icon gravel-to-blue collapse-settings" @click="configPanelCollapse()" type="button">
          <span class="sr-only">Collapse/Reveal Configuration Panel</span>
          <span class="icon arrow-double"></span>
        </button>
      </prefix>
      <column>
        <h4 class="dark">
          Configuration Panel
        </h4>
      </column>
    </row>

    <template v-if="selectedObjectModelProperty">
      <row class="panel-title">
        <prefix>
          <icon :class="selectedObjectModelProperty.icon"></icon>
        </prefix>
        <column>
          <h5 class="dark">
            {{ selectedObjectModelProperty.displayName }}
          </h5>
        </column>
      </row>

      <scroll-area class="panel">
        <div class="control-group">
          <control-group group-name="Define">
            <tab-define></tab-define>
          </control-group>
          <control-group group-name="Configure">
            <tab-configure></tab-configure>
          </control-group>
          <control-group group-name="Add Metadata">
            <tab-metadata></tab-metadata>
          </control-group>
        </div>
      </scroll-area>
    </template>

    <template v-else-if="selectedPropertySection">
      <row class="panel-title">
        <prefix>
          <icon :class="selectedPropertySection.icon"></icon>
        </prefix>
        <column>
          <h5 class="dark">
            {{ selectedPropertySection.displayName }}
          </h5>
        </column>
      </row>

      <scroll-area class="panel">
        <div class="control-group">
          <control-group group-name="Define">
            <property-section-tab-define></property-section-tab-define>
          </control-group>
        </div>
      </scroll-area>
    </template>

    <div v-else class="empty-box">
      <p>Select a control to customize it</p>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import TabDefine from "./view-properties-section-config-panel-tab-define.vue"
  import PropertySectionTabDefine from "./view-properties-section-config-panel-property-section-tab-define.vue"
  import TabConfigure from "./view-properties-section-config-panel-tab-configure.vue"
  import TabMetadata from "./view-properties-section-config-panel-tab-metadata.vue"
  import selectedMixin from "../mixins/selectedMixin";
  import {ObjectModelPropertyCapability} from "../../../common/models/objectModelProperties/objectModelPropertyCapability";

  export default Vue.extend({
    props: {},
    mixins: [selectedMixin],
    components: {
      TabDefine,
      PropertySectionTabDefine,
      TabConfigure,
      TabMetadata,
    },
    data: function () {
      return {
        ObjectModelPropertyCapability,
      };
    },
  });
</script>